import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Callout } from "@radix-ui/themes";

type NotificationProps = {
    id: string;
    message: string;
    isViewed: boolean;
    onMarkAsRead: (id: string) => void;
  };
export const AlertNotification: React.FC<NotificationProps> = ({ id, message, isViewed, onMarkAsRead }) => {
    return (
      <Callout.Root>
        <Callout.Icon>
          <InfoCircledIcon />
        </Callout.Icon>
        <Callout.Text>
          {message}
          <div style={{ marginTop: '10px' }}>
            {!isViewed && (
              <button
                onClick={() => onMarkAsRead(id)}
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  padding: '5px 10px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Marcar como lida
              </button>
            )}
            {/* {isViewed && <span style={{ color: '#4CAF50' }}>Marcada como lida</span>} */}
          </div>
        </Callout.Text>
      </Callout.Root>
    );
  };